export const EventCardSkeleton = () => {
  return (
    <div role="status" className="rounded-md shadow animate-pulse mt-6">
      <div className="flex items-center justify-center h-56 mb-6 bg-gray-300 rounded dark:bg-[#24262a]">
        <svg
          className="w-10 h-10 text-gray-200 dark:text-gray-600"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 16 20"
        >
          <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z" />
          <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z" />
        </svg>
      </div>
      <div className="h-2.5 bg-gray-200 rounded-full dark:bg-[#24262a] w-48 mb-6"></div>
      <div className="h-2 bg-gray-200 rounded-full dark:bg-[#24262a] mb-2.5"></div>
      <div className="h-2 bg-gray-200 rounded-full dark:bg-[#24262a] mb-2.5"></div>
      <div className="h-2 bg-gray-200 rounded-full dark:bg-[#24262a]"></div>
      <span className="sr-only">Loading...</span>
    </div>
  );
};
export const DefaultPlaceholder = () => {
  return (
    <div
      role="status"
      className="flex items-center justify-center h-64 bg-gray-300 rounded-lg animate-zoomIn dark:bg-[#24262a]"
    >
      <svg
        className="w-10 h-10 text-gray-200 dark:text-gray-500"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 20 18"
      >
        <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
      </svg>
    </div>
  );
};

export const EventDetails = () => {
  return (
    <div role="status" className=" animate-pulse space-y-2.5 w-full mt-10">
      <div className="pb-10">
        <div className="grid w-full grid-cols-4 items-center gap-x-4">
          <div className="h-8 rounded bg-gray-200 dark:bg-[#24262a]"></div>
          <div className="h-8 rounded bg-gray-300 dark:bg-[#24262a]"></div>
          <div className="h-8 w-full rounded bg-gray-300 dark:bg-[#24262a]"></div>
          <div className="h-8 w-full rounded bg-gray-300 dark:bg-[#24262a]"></div>
        </div>
        <div className="mt-2 h-8 w-full rounded bg-gray-300 dark:bg-[#24262a]"></div>
      </div>
      <div className="flex flex-col space-y-2 pb-10">
        <div className="h-3 w-44 rounded bg-gray-200 dark:bg-[#24262a]"></div>
        <div className="flex items-center gap-x-3 w-full">
          <div className="h-12 w-12 rounded-full bg-gray-300 dark:bg-[#24262a]"></div>
          <div>
            <div className="h-3 w-32 mb-2 rounded bg-gray-300 dark:bg-[#24262a]"></div>
            <div className="h-3 w-32 rounded bg-gray-300 dark:bg-[#24262a]"></div>
          </div>
        </div>
      </div>
      <div className="flex flex-col space-y-2">
        <div className="h-3 w-44 rounded bg-gray-200 dark:bg-[#24262a]"></div>
        <div className="flex flex-col space-y-1.5 gap-x-3 w-full">
          <div className="h-1 w-full rounded bg-gray-300 dark:bg-[#24262a]"></div>
          <div className="h-1 w-full rounded bg-gray-300 dark:bg-[#24262a]"></div>
          <div className="h-1 w-full rounded bg-gray-300 dark:bg-[#24262a]"></div>
          <div className="h-1 w-full rounded bg-gray-300 dark:bg-[#24262a]"></div>
          <div className="h-1 w-full rounded bg-gray-300 dark:bg-[#24262a]"></div>
          <div className="h-1 w-full rounded bg-gray-300 dark:bg-[#24262a]"></div>
        </div>
      </div>
    </div>
  );
};
